import { track } from '@/lib/analytics';
import { gabaritoMaterial } from '@/modules/tenant/domain/entities/materials';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import { linkProps } from '@/modules/simulado/presentation/components/EnsaioMaterials';

/**
 * "Baixar o gabarito": baixa o PDF de `materiais/<prova>/<ano>/gabarito.pdf`;
 * sem ele, não existe. Não depende do envio nem do gabarito oficial na API.
 */
export function GabaritoDownloadLink() {
  const { exam, edition } = useTenant();
  const material = gabaritoMaterial(exam, edition);
  if (!material) return null;

  return (
    <a
      className="ghost"
      {...linkProps(material)}
      onClick={() => track({ event: 'gabarito_download_clicado' })}
    >
      Baixar o gabarito
    </a>
  );
}
